/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { ElementRef, Injectable } from '@angular/core';
import { DomService } from './dom.service';

@Injectable({ providedIn: 'root' })
export class ModalService {
  private static modalContainerRef;

  constructor(private domService: DomService) {}

  init(container: ElementRef) {
    ModalService.modalContainerRef = container;
  }

  showModal(component: any, inputs = {}, outputs = {}) {
    if (!ModalService.modalContainerRef) {
      console.error('Modal Container not initialized');
      return;
    }

    const componentConfig = {
      inputs,
      outputs,
    };
    const newComponentInstance = this.domService.appendComponentTo(
      ModalService.modalContainerRef,
      component,
      componentConfig
    );
    ModalService.modalContainerRef.nativeElement.className = 'show';
    return newComponentInstance;
  }

  hideModal() {
    if (!ModalService.modalContainerRef) {
      console.error('Modal Container not initialized');
      return;
    }

    this.domService.removeComponent();
    ModalService.modalContainerRef.nativeElement.className = 'hidden';
  }
}
